import React, { Children, cloneElement, Component } from 'react'
import styled from 'styled-components'
import Collapse from 'react-collapse'

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const Header = styled.div`
  height: 2em;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid black;
  font-size: 1.5em;
  font-weight: bold;
`

export default class Accordion extends Component {
  state = {}
  toggleSectionCollapse = id => () =>
    this.setState(state => ({
      [`${id}Open`]: !state[`${id}Open`],
    }))
  render() {
    const {
      data,
      headerComponent: HeaderComponent,
      children,
      disabled,
      disabledOnClick = () => {},
      ...restProps
    } = this.props
    return (
      <div {...restProps}>
        {React.Children.map(children, (child, i) => (
          <SectionWrapper key={child.props.id || i}>
            {HeaderComponent
              ? <HeaderComponent
                  onClick={
                    disabled
                      ? disabledOnClick
                      : this.toggleSectionCollapse(child.props.id || i)
                  }
                  panelIndex={i}
                  {...data[i]}
                />
              : <div
                  onClick={
                    disabled
                      ? disabledOnClick
                      : this.toggleSectionCollapse(child.props.id || i)
                  }>
                  {typeof child.props.header === 'string'
                    ? <Header>{child.props.header}</Header>
                    : child.props.header}
                </div>}
            <Collapse
              isOpened={this.state[`${child.props.id || i}Open`] || false}>
              {cloneElement(child, { header: undefined })}
            </Collapse>
          </SectionWrapper>
        ))}
      </div>
    )
  }
}

// this component just strips the `header` props from the its child
// eslint-disable-next-line no-unused-vars
export function Section({ header, children, ...restProps }) {
  return cloneElement(Children.only(children), restProps)
}



// WEBPACK FOOTER //
// ./src/Units/components/Accordion.js